// Base URLs
// export const baseUrl = "http://localhost:5000";
//export const baseUrl = "https://finelabs-backend.onrender.com";
export const baseUrl = "https://yfzshf2eqz.ap-south-1.awsapprunner.com";

export const capitalizeFirstLetter = (str) => {
	if (str.length === 0) return str; // Return empty string if input is empty
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const removeRupeeSymbol = (value) => {
	// Remove the ₹ symbol and any other non-numeric characters, then parse the number
	return parseFloat(value.replace(/[^\d.-]/g, ""));
};

export const splitString = (input) => {
	// Using regular expression to split the string into two parts
	const regex = /(hello)(.*)/;
	const match = input.match(regex);

	if (match) {
		return {
			firstPart: match[1], // "hello"
			secondPart: match[2].trim(), // "(Hello, Hello)"
		};
	} else {
		return {
			firstPart: null,
			secondPart: null,
		};
	}
};

// Filter data
export const allFilterText = {
	"Popular Lab Tests": [
		"Complete Blood Count (CBC)",
		"Metabolic Panel Essential",
		"Comprehensive Metabolic Panel",
		"Lipid Profile Test",
		"Thyroid Profile Test",
		"Haemoglobin (Hb)",
		"Urine analysis",
		"Pregnancy Test Urine Spot",
		"Liver Function Test (LFT)",
		"PSA Profile",
		"Vitamin D Test",
		"CRP Test (C Reactive Protein Test)",
		"Blood Culture - Manual",
		"HIV-1 Monitor Test",
		"Kidney Function Test (KFT)",
		"Erythrocyte Sedimentation Rate (ESR)",
		"Iron Studies (Iron, TIBC, UIBC, % Saturation)",
		"B Type Natriuretic Peptide (BNP) Test",
		"Coagulation Panel Test",
		"PAP (Papanicolaou) Smear",
		"Vitamin B12 Test",
		"Hepatitis Screening Panel",
		"Mono Test (Infectious Mononucleosis)",
		"Rheumatoid Factor (RF), Quantitative",
		"Fasting Plasma Glucose",
		"Creatine Kinase MB Test",
		"Testosterone Free & Total",
		"Food Intolerance Test",
		"D-Dimer Panel-Automated (D-Dimer, CRP)",
		"Celiac Disease Profile",
		"Human Chorionic Gonadotropin (Beta HCG)",
		"HBOC Panel (3 Genes)",
		"Anti Nuclear Antibodies (ANA), IFA",
		"RBC Folate Test",
		"Culture, Sputum",
		"BLOOD GAS ANALYSIS (ABG)",
		"Sickling Test",
		"LYME Disease (Borrelia Burgdorferi) IgG Antibodies Test",
		"Culture, Stool",
	],
	"Risk-Based Testing": ["Blood", "Heart", "Liver", "Kidney", "Bones"],
	"Specialized Tests": [
		"Allergy Testing",
		"Ammonia Test",
		"Arterial Blood Gas (ABG)",
		"Antinuclear Antibody (ANA) Test",
		"B-type Natriuretic Peptide (BNP) Test",
		"BRCA1/BRCA2 Genetic Testing",
		"C-Reactive Protein (CRP) Test",
		"Celiac Disease Test (e.g., tTG-IgA)",
		"Cortisol Test",
		"D-dimer Test",
		"DNA Testing (e.g., for genetic conditions)",
		"Electrolyte Panel",
		"Erythrocyte Sedimentation Rate (ESR)",
		"Fertility Hormone Tests (e.g., FSH, LH, AMH)",
		"Fecal Occult Blood Test (FOBT)",
		"Follicle-Stimulating Hormone (FSH) Test",
		"Glycated Hemoglobin (Hemoglobin A1c) Test",
		"H. Pylori Breath Test",
		"Hepatitis B & C Panels",
		"Human Chorionic Gonadotropin (hCG) Test",
		"Human Papillomavirus (HPV) Test",
		"Immunoglobulin E (IgE) Test",
		"Lipid Panel (Cholesterol, Triglycerides)",
		"Liver Function Test (LFT)",
		"Luteinizing Hormone (LH) Test",
		"Magnesium Test",
		"Pap Smear (Cervical Cancer Screening)",
		"Parathyroid Hormone (PTH) Test",
		"Prostate-Specific Antigen (PSA) Test",
		"Rheumatoid Factor (RF) Test",
		"Sickle Cell Anemia Test",
		"Sleep Apnea Test (Polysomnography)",
		"Sputum Culture",
		"Thyroid Stimulating Hormone (TSH) Test",
		"Transferrin Saturation Test (Iron Overload)",
		"Troponin I/T Test (Cardiac Markers)",
		"Urine Culture",
		"Mammogram (Breast Cancer Screening)",
		"Mononucleosis (Mono) Test",
	],

	"Super Specialty Tests": [
		"Advanced Lipid Profile",
		"Genetic Testing for Cancer",
		"Cardiac Stress Test",
		"Cytogenetic Testing",
		"Digital Rectal Examination (DRE) with PSA",
		"Flow Cytometry for Leukemia/Lymphoma",
		"Bone Marrow Biopsy",
		"NGS (Next-Generation Sequencing) for Genetic Disorders",
		"Gene Expression Profiling for Cancer",
		"Whole Genome Sequencing",
		"Allergy Patch Testing",
		"Organ Transplant Compatibility Testing",
		"Liver Biopsy for Cirrhosis or Hepatitis",
		"Autologous Stem Cell Transplantation Monitoring",
		"Immunohistochemistry (IHC) for Cancer Staging",
		"Autoimmune Panel (for diseases like lupus, vasculitis)",
		"Endomyocardial Biopsy for Heart Disease",
		"DNA Methylation Test for Cancer Risk",
		"Magnetic Resonance Angiography (MRA)",
		"3D Mammography (Tomosynthesis)",
		"Fetal DNA Testing (NIPT) for Genetic Conditions",
		"Hormone Receptor Testing (for Breast Cancer)",
		"Liquid Biopsy for Cancer Detection",
		"Mutation Testing (e.g., KRAS, EGFR for lung cancer)",
		"Mitochondrial DNA Testing",
		"Bone Density Testing (DEXA scan)",
	],
	"Popular Packages": [
		"MotherHealth Platinum Package",
		"Early Detection Package",
		"Full Body checkup Basic 1",
		"HEALTHKIND MINI",
		"Thyroid Preventive Care Package",
		"Fitness Package Essential",
		"Healthy Heart Premium Package",
		"Arthritis Package - Comprehensive",
		"Advanced Full Body Check",
		"Master Full Body Health Checkup - Male (with cancer screening)",
		"Comprehensive Health Package",
		"Allergy Screening Package - Essential",
		"Low Energy Screening Package",
		"HEALTHKIND MINI (BSF/BSR, Total Cholesterol, SGOT, SGPT, AST/ALT Ratio, Creatinine, TSH)",
		"STD Panel Comprehensive",
		"Full Body Check Up With Smoking Impact Assessment Profile",
		"Gut Health Package",
		"Healthkind Pollution Check (CBC+ESR, CRP Quantitative, Lipid Profile ((Total Cholesterol, Triglycerides, LDL Calculated, HDL, VLDL, CHOL/HDL Ratio, LDL/HDL Ratio), IgE Total",
		"TruHealth - Superwoman",
		"TruHealth Hair Loss Monitor",
		"HEALTHKIND MINI (BSF/BSR, Total Cholesterol, SGOT, SGPT, AST/ALT Ratio, Creatinine, TSH)",
	],
	"Full Body Packages": [
		"Full Body checkup Basic 1",
		"Full Body Check Up With Smoking Impact Assessment Profile",
		"Smart Plus Full Body Checkup With Vitamin & Arthritis (RA Factor) Test",
		"HEALTHKIND TOTAL PLUS (CBC, BSF/BSR, HbA1c, Lipid Profile, Kidney Function Test (Urea, BUN, Creatinine, BUN/Creatinine Ratio, Uric Acid), Liver Function Test (Bilirubin Total, Direct & Indirect, SGOT, SGPT, AST/ALT Ratio, ALP, Total Protein, Albumin, Globulin, A/G Ratio), TSH, Urine R/M) + Ferritin, CRP & GGT, Calcium, Phosphorus, Electrolytes (Na/K/Cl), T3, T4, Vitamin D 25 - Hydroxy",
		"Smart Plus Full Body Checkup",
		"Father's Special Care Package",
		"Prime Full body Check Up",
		"Advanced Full Body Check",
		"Swasth Bharat Full Body Checkup",
		"Smart Plus Full Body Checkup with Vitamin Screening & Free Heart Risk Assessment (HsCRP)",
		"Senior Citizen Full Body Checkup - Male (Advance)",
		"Senior Citizen Full Body Checkup - Female (Advance)",
		"Master Full Body Checkup Package - Women",
		"HIV 1 and 2 Antibodies with full body screening",
		"Executive Full Body Checkup - Female (Comprehensive)",
		"Master Full Body Health Checkup - Male (with cancer screening)",
	],

	"Digital X-rays": [
		"Digital Chest X-Ray Lateral",
		"Digital X-Ray Both Hip (Pelvis)",
		"Digital X-Ray Hip Joints Lateral",
		"Digital X-Ray Wrist AP",
		"Digital X-Ray Leg AP (Single)",
		"Digital X-Ray Scapula AP",
		"Digital X-Ray Ankle Lateral(Single)",
		"Digital X-Ray Calcaneum / Heel Lateral",
		"Digital X-Ray Arm AP(Single)",
		"Digital X-Ray Hand AP(Single)",
		"Digital X-Ray Forearm Lateral(Single)",
		"Digital X-Ray SI – Sacro Iliac Joints La",
		"Digital X-Ray Abdomen (Erect)",
		"Digital X-Ray Finger Lateral",
		"Digital X-Ray Foot AP",
		"Digital X-Ray Sacrum Lateral",
		"Digital X-Ray Dorso-Lumbar Spine Lateral",
		"Digital X-Ray Dorsal Spine AP",
		"Digital X-Ray Elbow AP",
		"Digital X-Ray Shoulder Lateral",
		"Digital X-Ray Coccyx Lateral",
		"Digital X-Ray Knee Skyline",
		"Digital X-Ray Skull AP",
		"Digital X-Ray PNS(Waters View)",
		"Digital X-Ray Nasal Bone Lateral",
		"Digital X-Ray Soft Tissue Neck Lateral",
	],
	Ultrasound: [
		"USG Early Obstetric",
		"USG Biophysical Profile",
		"USG Level 1",
		"USG Level 2",
		"USG Level 2 (Twins)",
		"USG Small Parts",
		"USG Whole Abdomen",
		"USG KUB (Kidney, Ureter, Urinary Bladder)",
		"USG Neck/ThyroidUSG Obstetric (Twins)",
		"USG Early Obstetric (TVS)",
		"USG Trans Vaginal",
		"USG Lower Abdomen/Pelvis",
		"USG Soft Parts",
		"USG Follicle Monitoring – Single Day",
		"USG Follicular Basal Studies Antral",
		"USG Follicular Studies TVS : 4 Visits",
		"USG Parotid Gland",
		"USG Single Breast",
		"USG Both Breast",
		"USG Both Scrotum",
		"USG for Single Joint",
		"USG Lower Abdomen",
		"USG Upper Abdomen",
		"Color Doppler Small Parts",
		"Color Doppler Neck",
		"Color Doppler Obstetric",
		"Color Doppler Scrotum",
		"Color Doppler Carotid",
		"Color Doppler Thyroid",
		"Color Doppler Abdomen/Pelvis",
		"Color Doppler Single Limb",
	],
	"X-rays & Scans Center": ["Gurugram", "Varanasi", "Kolkata"],
	More: ["2-D ECHO", "ECG", "TMT", "FNAC", "AUDIOMETRY", "PFT(Spirometry)"],
};
